import '@nobleclem/jquery-multiselect';

const Multiselect = {
    init: function (form) {
        this.el = form.find("select[multiple]").not(".chosen");
        if(!this.el.length) return;

        const selected = " " + window.T.STL.selected2;
        const placeholder= window.T.STL.select_placeholder;


        this.el.each(function () {
            const $select = $(this);


            $(this).multiselect({
                placeholder: $select.is("[placeholder]") ? $select.attr("placeholder") : placeholder,
                texts: {
                    selectedOptions: selected,
                },
                columns: 1,
                search: false,
                // permanentOpen: false,
                deselectAllButton: true,
                // search filter options
                searchOptions: {
                    default: 'Vyhľadávanie', // search input placeholder text
                    showOptGroups: false     // show option group titles if no options remaining
                },
                // add select all option
                selectAll: false,
                // select entire optgroup
                selectGroup: false,
                // minimum height of option overlay
                minHeight: 40,
                // maximum height of option overlay
                maxHeight: 300,
                // display the checkbox to the user
                showCheckbox: false,
                // options for jquery.actual
                jqActualOpts: {},
                // maximum width of option overlay (or selector)
                maxWidth: null,
                // minimum number of items that can be selected
                minSelect: false,
                // maximum number of items that can be selected
                maxSelect: false,

                onOptionClick: function (element, option) {
                    if ($select.find('option:selected').length > 0 && $select.is('[deselectable]')) {
                        $select.prev('.button.close').removeClass('hidden');
                    } else {
                        $select.prev('.button.close').addClass('hidden');
                    }

                    if ($select.find('option:selected').length > 4 ) {
                        $select.multiselect( 'settings', { texts: {selectedOptions: " " + window.T.STL.selected5} });
                    } else {
                        $select.multiselect( 'settings', { texts: {selectedOptions: " " + window.T.STL.selected2} });
                    }
                }
            });

            // len pre deselectable multiselecty je vytvorený button na ich vyčistenie
            if (!$(this).is('[deselectable]')) return;

            var closeButton = $('<div>', {"class": "button close icon transparent hidden"});
            var isSelected = $(this).find('option:selected').length > 0;

            if (isSelected) closeButton.removeClass('hidden');

            closeButton.click(function (evt) {
                $(this).addClass('hidden');
                var select = $(this).next('select[multiple]');
                select.find('option:selected').removeAttr("selected");
                select.trigger('change');
                select.multiselect('reload');
            });

            closeButton.insertBefore($(this));


        });
    }
}

export default Multiselect;